import React, { useEffect, useState } from "react"

import { db } from "../../../utils/firebase"
import Table from "../../../components/structure/table/table"
import { LoadingIcon } from "../../../utils/svgs"

import QueueRow from "./queue-row"

/**
 * Enquiry Queue tab — table of enquiries forwarded into the development
 * queue from monitored mailboxes. Each row shows the bare denormalised
 * details + a Parse button that runs the Development-tab settings against
 * the queued enquiry and writes the result back to the doc.
 *
 * Read-only listing — adds happen out-of-band (the user wires up forwarding
 * actions on monitored mailboxes that drop docs into `enquiry_queue`).
 */
function EnquiryQueueTab() {
	const [entries, setEntries] = useState([])
	const [loading, setLoading] = useState(true)

	useEffect(() => {
		const unsubscribe = db
			.collection("enquiry_queue")
			.orderBy("forwarded_at", "desc")
			.onSnapshot(
				(snapshot) => {
					setEntries(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })))
					setLoading(false)
				},
				(err) => {
					console.error("Failed to subscribe to enquiry_queue", err)
					setLoading(false)
				}
			)

		return () => unsubscribe()
	}, [])

	return (
		<>
			<Table
				className="mailboxes-table"
				headings={[
					"Added to queue",
					"Parsed",
					"Client name",
					"Client email",
					"Client phone",
					"Status",
					"Fields completed",
					"",
				]}
				noResults={!loading && entries.length === 0}
				noResultsMessage="No queued enquiries yet — set up a forwarder on a monitored mailbox to drop them here.">
				{entries.map((entry) => (
					<QueueRow
						key={entry.id}
						entry={entry}
					/>
				))}

				{loading && (
					<div className="table-loading-splash">
						<div className="loading-wrapper">
							<p>Loading...</p>
							<div className="svg-loading-wrap">
								<LoadingIcon />
							</div>
						</div>
					</div>
				)}
			</Table>
		</>
	)
}

export default EnquiryQueueTab
